import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { action } from '@ember/object';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import { linkToAction } from 'ember-route-state/decorators/link-to-action.js';

@linkToAction
export default class LinkToActionComponent extends Component {
  get linkToParams() {
    return this.args.linkTo || this.args.params;
  };

  @action onClick(e) {
    e.stopPropagation();
    if (!this.args.disabled) {
      this.callLinkToAction(...arguments);
    }
  }

  <template>
    <LinksTo @route={{this.paramsForLinkTo}}
      class={{@linkClass}}
      @disabled={{@disabled}}
      {{on "click" this.onClick}}
      ...attributes
    ><span>{{yield}}</span></LinksTo>
  </template>
}
